import { render, staticRenderFns } from "./CadastroSociedadeMedica.vue?vue&type=template&id=5a354ce6&"
import script from "./CadastroSociedadeMedica.vue?vue&type=script&lang=js&"
export * from "./CadastroSociedadeMedica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports